import { CountBadgeV2 } from "@/components/interactive/CountBadgeV2";
import { classNames } from "@/utils/classnames";
import React from "react";

export interface KeyboardShortcutV2Props extends React.ComponentProps<"span"> {
  keys: readonly string[];
  joiner?: React.ReactNode;
  keyClassName?: string;
  withStroke?: boolean;
}

const KeyboardShortcutV2Base: React.FC<KeyboardShortcutV2Props> = ({
  className,
  joiner,
  keyClassName,
  keys,
  withStroke = true,
  ...rest
}) => (
  <span
    className={classNames(
      "inline-flex shrink-0 items-center gap-cds-4 text-cds-xs text-cds-ink-muted dark:text-zinc-500",
      className,
    )}
    {...rest}
  >
    {keys.map((key, index) => (
      <React.Fragment key={`${key}-${index}`}>
        {index > 0 && joiner != null && <span>{joiner}</span>}
        <CountBadgeV2
          as="kbd"
          className={classNames("min-w-4", keyClassName)}
          withStroke={withStroke}
        >
          {key}
        </CountBadgeV2>
      </React.Fragment>
    ))}
  </span>
);

export const KeyboardShortcutV2 = React.memo(KeyboardShortcutV2Base);
KeyboardShortcutV2.displayName = "KeyboardShortcutV2";
